import { useMutation } from '@tanstack/react-query';
import type {
	LWApiPublicAssetUpdateParamsRawI,
	LWApiPublicAssetUpdateResultRawI,
} from '@liquidweb-dev/club-sauce/public/asset/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import useInvalidateAssets from 'modules/queries/invalidateQueries/useInvalidateAssets';
import useSnackbarError from 'utility/hooks/useSnackbarError';

const useAssetUpdate = () => {
	const snackbarError = useSnackbarError();
	const invalidateAssets = useInvalidateAssets();

	return useMutation<
		LWApiPublicAssetUpdateResultRawI,
		ApiErrorI,
		LWApiPublicAssetUpdateParamsRawI
	>({
		mutationFn: (params) => api.asset.apiRaw.update(params),

		onSuccess: (_data, params) => {
			invalidateAssets(params.uniq_id);
		},

		onError: snackbarError,
	});
};

export default useAssetUpdate;
